import { createContext } from 'react';

export type Status = 'uninitialized' | 'initializing' | 'completed' | 'failed';

type InternalContextType = {
  status: Status;
};

export const InternalContext = createContext<InternalContextType>({
  status: 'uninitialized',
});
